module.exports = __webpack_public_path__ + "img/mica.e3afed09.svg";